export {default as Backpack} from './Backpack'
export {default as Bed} from './Bed'
export {default as Building} from './Building'
export {default as Bus} from './Bus'
export {default as ElephantSad} from './ElephantSad'
export {default as ElephantSadSuitcase} from './ElephantSadSuitcase'
export {default as ElephantSpanner} from './ElephantSpanner'
export {default as Map} from './Map'
export {default as Passport} from './Passport'
export {default as Phone} from './Phone'
export {default as Suitcase} from './Suitcase'
export {default as Sunglasses} from './Sunglasses'
export {default as SunLounge} from './SunLounge'
export {default as Table} from './Table'
export {default as Triangle} from './Triangle'
